import { AnimatePresence, motion } from 'motion/react';

import { ComparisonIcon, StarIcon } from '../../../icons';

import * as css from './ActivityNavigationItem.css';

export type ActivityNavigationItemStatus = 'waiting' | 'analyzing' | 'ready' | 'error';

type ActivityNavigationItemProps = {
    id: string;
    status: ActivityNavigationItemStatus;
    number: number;
    iconSize: number;
    isComparison?: boolean;
    isFavorite?: boolean;
};

export const ActivityNavigationItem = ({
    id,
    status,
    number,
    iconSize,
    isComparison,
    isFavorite,
}: ActivityNavigationItemProps) => {
    return (
        <div className={css.itemBefore}>
            <div className={css.itemNumber({ status })}>{number}</div>

            <AnimatePresence>
                {isComparison && (
                    <motion.div
                        key={`${id}-comparison`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <ComparisonIcon width={iconSize} color={css.iconColors.comparison} />
                    </motion.div>
                )}

                {isFavorite && (
                    <motion.div
                        key={`${id}-favorite`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <StarIcon weight="fill" size={iconSize} color={css.iconColors.favorite} />
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
